import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
export const navItems = [{
  name: 'Herzlich willkommen',
  path: '/eva_schifferer'
}, {
  name: 'Paartherapie',
  path: '/eva_schifferer/paartherapie'
}, {
  name: 'Einzeltherapie',
  path: '/eva_schifferer/psychotherapie'
}, {
  name: 'Coaching',
  path: '/eva_schifferer/coaching'
}, {
  name: 'Mentale Gesundheit',
  path: '/eva_schifferer/mentale-gesundheit'
}, {
  name: 'Profil',
  path: '/eva_schifferer/profil'
}, {
  name: 'Info',
  path: '/eva_schifferer/info',
  subItems: [{
    name: 'Terminbuchung',
    path: '/eva_schifferer/info#terminbuchung'
  }, {
    name: 'Konditionen',
    path: '/eva_schifferer/info#konditionen'
  }, {
    name: 'Anfahrt',
    path: '/eva_schifferer/info#anfahrt'
  }]
}];
export function EvaSchiffererNavItems({
  isMobile = false,
  closeMobileMenu = () => {}
}) {
  const location = useLocation();
  const currentPath = location.pathname;
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);
  return navItems.map(item => <li key={item.path} className={isMobile ? '' : 'relative'} onMouseEnter={() => !isMobile && setHoveredItem(item.path)} onMouseLeave={() => !isMobile && setHoveredItem(null)} data-id="element-124">
      <Link to={item.path} className={`
          ${isMobile ? 'block py-2 text-base' : 'whitespace-nowrap text-sm lg:text-sm py-2'}
          ${currentPath === item.path ? 'text-[#c2cde0] font-semibold' : 'text-gray-600 hover:text-[#c2cde0]'} transition-colors
        `} onClick={isMobile ? closeMobileMenu : undefined} data-id="element-125">
        {item.name}
      </Link>
      {/* Dropdown Menu für Desktop */}
      {!isMobile && item.subItems && hoveredItem === item.path && <div className="absolute right-0 top-full pt-2 z-[100]" data-id="element-126">
          <div className="bg-white shadow-lg rounded-md py-2 min-w-[180px] border border-gray-100" data-id="element-127">
            {item.subItems.map(subItem => <Link key={subItem.path} to={subItem.path} className="block px-4 py-2 text-sm text-gray-600 hover:bg-gray-50 hover:text-[#c2cde0] transition-colors" data-id="element-128">
                {subItem.name}
              </Link>)}
          </div>
        </div>}
      {/* Subitems für Mobile */}
      {isMobile && item.subItems && <ul className="ml-4 mt-2 space-y-2" data-id="element-129">
          {item.subItems.map(subItem => <li key={subItem.path} data-id="element-130">
              <Link to={subItem.path} className="block py-1 text-sm text-gray-600 hover:text-[#c2cde0] transition-colors" onClick={closeMobileMenu} data-id="element-131">
                {subItem.name}
              </Link>
            </li>)}
        </ul>}
    </li>);
}
export function EvaSchiffererNav() {
  return null;
}